import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import IconCarbonUser from '@/shared/icons/IconCarbonUser'
import HOPSelect from '@/shared/components/HOPComponents/HOPSelect'
import { TYPE } from 'baseui/select'
import useMcpAdvisor from './useMcpAdvisor'

/**
 * Selectra-admin-only / FR-only picker letting the admin reassign the MCP
 * advisor on a contact that already has one. The selection is staged in the
 * contact slice (`personal.mcpAdvisoryId`) and persisted by the global
 * "Enregistrer les données du client" button along with the rest of the
 * contact payload (mcp_advisory_id).
 */
const McpAdvisor = () => {
  const { t, isVisible, optionsList, selectedValue, updateAdvisor } = useMcpAdvisor()

  if (!isVisible) return null

  return (
    <PanelNew
      id='McpAdvisorModule'
      alt={t('subscriptionForm:mcp_advisor.module_title')}
      title={t('subscriptionForm:mcp_advisor.module_title')}
      logo={<IconCarbonUser size={24} />}
    >
      <HOPSelect
        id='mcp-advisor-selector'
        type={TYPE.search}
        optionsList={optionsList}
        selectedValue={selectedValue}
        searchable={true}
        onChangeHandler={params => {
          const next = params.value[0]?.id
          if (next !== undefined) {
            updateAdvisor(next)
          }
        }}
      />
    </PanelNew>
  )
}

export default McpAdvisor
